"use strict";
/*
 * Created on 01 30 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var ModifiedCompetitorPriceDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ModifiedCompetitorPriceDTOConverter, _DataObjectConverter_);

  function ModifiedCompetitorPriceDTOConverter() {
    _classCallCheck(this, ModifiedCompetitorPriceDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ModifiedCompetitorPriceDTOConverter).apply(this, arguments));
  }

  return ModifiedCompetitorPriceDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ModifiedCompetitorPriceDTOConverter = ModifiedCompetitorPriceDTOConverter;